export default __webpack_public_path__ + "static/media/spinachsupercocktail-wide@2x.6abbb9d9.jpg";